import type { ApiV2PageStrateProgramsHighlight } from '@dce-front/hodor-types/api/v2/page/dtos/strates/programs_highlight';
import { Binder, type BinderProps } from '@dce-front/one-navigation';
import type { ResizeMode } from '@dce-front/onewebapp-utils';
import {
  ProgramsHighlight as SharedProgramsHighlight,
  type ProgramsHighlightProps as SharedProgramsHighlightProps,
} from '@dce-front/sharedcomponent';
import Linker from '../../../../components/Linker/Linker';
import {
  getContentAriaLabel,
  getLocationStateContext,
} from '../../../../helpers/contents/contents-helper';
import { useOnFocusable } from '../../../../helpers/hooks/useOnFocusable';
import type { FocusManager } from '../../../../helpers/oneNavigation/FocusManager';

const renderWrapperLinker: SharedProgramsHighlightProps['renderContentImageLinker'] =
  ({ content, children, id, classNames, trackingContext }) => {
    return (
      <Linker
        className={classNames}
        data={{
          mainOnClick: { ...content?.onClick, trackingContext },
          context: getLocationStateContext(content?.onClick?.displayTemplate),
        }}
        objKey="onClick"
        id={id}
        ariaLabel={getContentAriaLabel(content || {})}
      >
        {children}
      </Linker>
    );
  };

type ProgramsHighlightProps = {
  focusManager?: FocusManager;
  resizeMode?: ResizeMode;
  strate: ApiV2PageStrateProgramsHighlight;
} & Pick<BinderProps, 'binderId' | 'middleware'>;

function ProgramsHighlight({
  strate,
  binderId,
  focusManager,
  middleware,
  resizeMode,
}: ProgramsHighlightProps) {
  const [firstContent] = strate?.contents || [];
  useOnFocusable(focusManager, !!firstContent);

  return (
    <Binder
      binderId={binderId}
      middleware={middleware}
      enabled={!!firstContent}
    >
      <SharedProgramsHighlight
        content={firstContent}
        isTvDevice={$_BUILD_RENDERMODE_CSR}
        resizeMode={resizeMode}
        Linker={Linker}
        trackingContext={strate.context}
        renderContentImageLinker={renderWrapperLinker}
      />
    </Binder>
  );
}

export default ProgramsHighlight;
